import { useSpring, animated } from '@react-spring/web'
import { useSelector } from 'react-redux'
import { selectUrl } from 'hooks/urlInfo'

const NavigateButtonPrun = () => {
	const urlInfo = useSelector(selectUrl)

	const menuMove1 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 0,
	})
	const menuMove2 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 100,
	})

	// 기존 showIframe 파라미터를 제거하고 새 값을 추가하는 함수
	const getUrlWithShowIframe = (showIframe: boolean) => {
		const url = new URL(urlInfo, window.location.origin)
		url.searchParams.set('showIframe', String(showIframe))
		return url.pathname + url.search
	}

	const moveToHome = () => {
		// 홈 버튼: iframe이 보이는 상태로 이동
		window.location.href = getUrlWithShowIframe(false)
	}

	const moveBack = () => {
		// back 버튼: iframe이 안 보이는 상태로 이동
		window.location.href = getUrlWithShowIframe(false)
	}

	return (
		<ul className="btnContainer">
			<animated.li style={menuMove1}>
				<button
					type="button"
					className="btnHome"
					onClick={moveToHome}
				/>
			</animated.li>
			<animated.li style={menuMove2}>
				<button
					type="button"
					className="btnBack"
					onClick={moveBack}
				/>
			</animated.li>
		</ul>
	)
}

export default NavigateButtonPrun
